import { createSlice } from "@reduxjs/toolkit";

export const dataAppSlice = createSlice({
  name: "dataApp",
  initialState: {
    huerta: null,
    inversores: [],
    contadores: [],
    clientes: [],
    instalaciones: [],
  },
  reducers: {
    establecerHuerta: (state, action) => {
      state.huerta = action.payload;
    },
  },
});
// Action creators are generated for each case reducer function
export const { establecerHuerta } = dataAppSlice.actions;
